export default "<p>I've begun work on another car - stay tuned for its release!</p>\r\n\r\n<p><img src=\"/media/blog/another-work-in-progress/car.png\"/></p>";